// Only outline variant (partially - missing disabled, error states) implemented.
// This is almost identical to TextInput component. We need to merge them.
// Please use TextInput.

import { classNames } from "lib/utils";
import React, { forwardRef } from "react";

interface OwnProps {
  error?: boolean;
  suffix?: React.ReactNode;
  IconLeft?:
    | React.FunctionComponent<React.ComponentProps<"svg">>
    | React.FunctionComponent<React.ComponentProps<"img">>;
  addOnLeft?: React.ReactNode; // A gray box to the left of the input
  addOnRight?: React.ReactNode; // A gray box to the right of the input
}

type Props = OwnProps & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

const InputText = ({ className, error, IconLeft, suffix, addOnLeft, addOnRight, ...props }: Props, ref: any) => {
  return (
    <div
      className={classNames(
        "flex items-stretch justify-between overflow-hidden rounded border outline-none",
        "text-13-16 text-black",
        error ? "border-oldred-600" : "border-oldgray-400",
        error ? "hover:border-oldred-700" : "hover:border-oldgray-500",
        "focus-within:border-oldblue-600 focus-within:hover:border-oldblue-600",
        className,
      )}
      ref={ref}
    >
      {IconLeft && <IconLeft className="my-auto ml-12 h-16 w-16 text-oldgray-600" />}
      {addOnLeft && (
        <span className="inline-flex items-center rounded-l border border-r-0 border-oldgray-300 bg-oldgray-200 pl-12 pr-10 text-oldgray-600 sm:text-12-14">
          {addOnLeft}
        </span>
      )}
      <input
        className={classNames(
          "min-w-0 grow border-none px-12 py-[7px] outline-0 !ring-0 placeholder:text-oldgray-400",
          addOnLeft ? "pl-4" : "",
        )}
        {...props}
      />
      {suffix && <div className="flex items-center pr-12 text-oldgray-700">{suffix}</div>}
      {addOnRight && (
        <span className="inline-flex items-center rounded-r border border-r-0 border-oldgray-300 bg-oldgray-200 pl-12 pr-10 text-oldgray-600 sm:text-12-14">
          {addOnRight}
        </span>
      )}
    </div>
  );
};

export default forwardRef(InputText);
